/**
 * 全てのTREEお知らせ一覧を取得する
 * @returns 
 */
export async function selectTreeInformationList() {
    const url = `/tree/api/selectTreeInformationList`;
    const res = await fetch(url);
    const data = await res.json();
    return data;
}